<template>
  <layout>
    <page-header :header="$t('company.settings')" />
    <div class="content">
      <b-card v-if="$account">
        <span class="mr-2">
          <b>{{ $t('company.company_id') }}:</b>
          {{ $account.company.id }}
        </span>
        <span>
          <b> {{ $t('company.company_commission') }}: </b>
          {{ $account.company.commission }}%
        </span>
      </b-card>
      <resource-form v-if="$account" :id="$account.company.id" />
    </div>
  </layout>
</template>

<script>
import ResourceForm from '../companies/Form.vue'

export default {
  name: 'CompanyForm',
  components: {
    ResourceForm,
  },
}
</script>
